export default __webpack_public_path__ + "0bf23eac806a6b064963451b1ba6848a.svg";